// Thin top-of-app banner driven by the x-trial-days-remaining +
// x-subscription-status response headers (read in helpers/subscriptionState.js).
// Hidden when the company is healthy (status='active' or daysRemaining > 7).
// Three visual tiers:
//   - "trial" with 4-7d left:  neutral yellow heads-up
//   - "trial" with ≤3d left:   orange urgency
//   - "expired" / "suspended": red, full-width, can't be dismissed

import React, { useEffect, useState } from 'react';
import { subscribe } from 'helpers/subscriptionState';

const STYLES = {
  base: {
    width: '100%',
    padding: '8px 14px',
    fontSize: 13,
    fontWeight: 500,
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    flexWrap: 'wrap',
  },
  cta: {
    display: 'inline-block',
    padding: '4px 12px',
    borderRadius: 4,
    background: 'rgba(0,0,0,0.18)',
    color: 'inherit',
    textDecoration: 'none',
    fontWeight: 600,
  },
};

function tone({ status, daysRemaining }) {
  if (status === 'suspended') return { bg: '#a71d2a', fg: '#fff', label: 'Account suspended', detail: 'Contact support@prigmar.com to reactivate.' };
  if (status === 'expired')   return { bg: '#a71d2a', fg: '#fff', label: 'Subscription expired', detail: 'Your trial has ended — pick a plan to keep using Prigmar.' };
  if (status === 'trial' && daysRemaining != null && daysRemaining <= 3) {
    return { bg: '#d97706', fg: '#fff', label: `${daysRemaining} day${daysRemaining === 1 ? '' : 's'} left in your trial`, detail: 'Upgrade now to avoid an interruption.' };
  }
  if (status === 'trial' && daysRemaining != null && daysRemaining <= 7) {
    return { bg: '#f4c430', fg: '#15172b', label: `${daysRemaining} days left in your trial`, detail: 'Pick a plan whenever you\'re ready.' };
  }
  return null; // healthy — don't render
}

export default function TrialBanner() {
  const [sub, setSub] = useState({ daysRemaining: null, status: null });
  useEffect(() => subscribe(setSub), []);
  const t = tone(sub);
  if (!t) return null;
  return (
    <div style={{ ...STYLES.base, background: t.bg, color: t.fg }}>
      <span><strong>{t.label}.</strong> {t.detail}</span>
      <a href="/billing" style={{ ...STYLES.cta, color: t.fg }}>Upgrade</a>
    </div>
  );
}
